import { render, staticRenderFns } from "./CircuitDocs.vue?vue&type=template&id=3563b9f4&scoped=true&"
import script from "./CircuitDocs.vue?vue&type=script&lang=ts&"
export * from "./CircuitDocs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3563b9f4",
  null
  
)

export default component.exports